/**
 * A sentence naming the Terms of Service and the Privacy Policy, with both
 * names as links. The sentence is ONE catalog string with {terms} and
 * {privacy} placeholders, so a translation can reorder it. The links open in
 * a new tab: following one from a half-filled signup form must not throw the
 * form away.
 */
import React from 'react';
import { t, type MessageKey } from '@/i18n';

const LINKS = {
  terms: { href: '/terms', label: 'legal.termsLink' },
  privacy: { href: '/privacy', label: 'legal.privacyLink' },
} as const;

type Placeholder = keyof typeof LINKS;

function isPlaceholder(part: string): part is Placeholder {
  return part in LINKS;
}

interface LegalAgreementProps {
  /** A catalog sentence containing {terms} and {privacy}. */
  template: MessageKey;
  linkClassName?: string;
}

export const LegalAgreement: React.FC<LegalAgreementProps> = ({
  template,
  linkClassName = 'text-black underline hover:no-underline',
}) => (
  <>
    {t(template).split(/\{(terms|privacy)\}/).map((part, i) =>
      isPlaceholder(part) && i % 2 === 1 ? (
        <a key={i} href={LINKS[part].href} target="_blank" rel="noopener noreferrer" className={linkClassName}>
          {t(LINKS[part].label)}
        </a>
      ) : (
        <React.Fragment key={i}>{part}</React.Fragment>
      ),
    )}
  </>
);
